import { useNavigate } from "react-router-dom";
import { useStore } from "@/context/StoreContext";
import TaxInvoiceView from "@/pages/invoices/components/TaxInvoiceView";

export default function PosReceiptPage() {
  const navigate = useNavigate();
  const { lastReceipt } = useStore();

  if (!lastReceipt) {
    return (
      <div className="yc-fade-up bg-white rounded-card border border-background-200 shadow-card px-8 py-20 text-center">
        <div className="mx-auto w-16 h-16 flex items-center justify-center rounded-full bg-background-100 text-foreground-400 mb-4">
          <i className="ri-receipt-line text-3xl"></i>
        </div>
        <h2 className="text-lg font-bold text-foreground-950">
          لا يوجد إيصال حالي
        </h2>
        <p className="mt-1 text-sm text-foreground-500">
          أكمل عملية بيع من نقطة البيع لعرض الإيصال هنا.
        </p>
        <button
          type="button"
          onClick={() => navigate("/pos")}
          className="mt-5 inline-flex items-center gap-2 rounded-btn bg-primary-500 px-5 py-2.5 text-sm font-semibold text-white hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-arrow-right-line"></i>
          العودة لنقطة البيع
        </button>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="yc-screen-only yc-fade-up flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-3">
          <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500 text-white">
            <i className="ri-checkbox-circle-line text-xl"></i>
          </span>
          <div>
            <h2 className="text-xl font-bold text-foreground-950">
              تم إتمام البيع بنجاح
            </h2>
            <p className="mt-1 text-sm text-foreground-500" dir="ltr">
              {lastReceipt.id}
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => navigate("/pos")}
            className="inline-flex items-center gap-2 rounded-btn border border-background-200 bg-white px-4 py-2.5 text-sm font-semibold text-foreground-800 hover:bg-background-100 transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-shopping-cart-2-line"></i>
            عملية بيع جديدة
          </button>
          <button
            type="button"
            onClick={() => window.print()}
            className="inline-flex items-center gap-2 rounded-btn bg-primary-500 px-5 py-2.5 text-sm font-semibold text-white hover:bg-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-printer-line"></i>
            طباعة الفاتورة
          </button>
        </div>
      </div>

      <div className="yc-screen-only yc-fade-up bg-white rounded-card border border-background-200 shadow-card overflow-hidden">
        <TaxInvoiceView invoice={lastReceipt} />
      </div>

      <div className="yc-print-only">
        <TaxInvoiceView invoice={lastReceipt} />
      </div>
    </div>
  );
}